import React, { ReactElement } from 'react'
import { CrossClientQueryLogicalQuestionDecomposition, CrossClientQueryResultMatch, CrossClientQueryResultMatches } from '../../../../models/CrossClient'
import { ReactComponent as StrongMatchIcon } from '../../../../assets/images/strong-match.svg'
import { ReactComponent as WeakMatchIcon } from '../../../../assets/images/weak-match.svg'
import { ReactComponent as PartialMatchIcon } from '../../../../assets/images/partial-match.svg'
import { CrossClientQueryResultCellProps } from './types'
import { OverlayTrigger, Popover } from 'react-bootstrap'

interface CrossClientQueryResultMatchCellProps extends CrossClientQueryResultCellProps {
  decomposition: CrossClientQueryLogicalQuestionDecomposition
}

const MATCH_MAPPING: Record<CrossClientQueryResultMatch, { icon: ReactElement; label: string }> = {
  [CrossClientQueryResultMatches.STRONG]: { icon: <StrongMatchIcon />, label: 'Strong' },
  [CrossClientQueryResultMatches.WEAK]: { icon: <WeakMatchIcon />, label: 'Weak' },
  [CrossClientQueryResultMatches.PARTIAL]: { icon: <PartialMatchIcon />, label: 'Partial' },
}

export const CrossClientQueryResultMatchCell: React.FC<CrossClientQueryResultMatchCellProps> = ({ decomposition, result }) => {
  const { match, answers } = result
  const { icon: matchIcon, label: matchLabel } = MATCH_MAPPING[match] ?? { icon: null, label: '' }

  const popover = (
    <Popover id='popover-match' className='cross-client-match-popover'>
      <Popover.Body>
        {!answers ? (
          <div>No data available for this client</div>
        ) : (
          decomposition.atomicClauses.map((clause, index) => {
            const answer = answers[index]
            return (
              <div key={index} className='d-flex flex-column'>
                <span>
                  <strong>{clause.questionForm}</strong> : {JSON.stringify(answer.decision)}
                </span>
                <span>
                  <strong>Explanation:</strong> {answer.explanation}
                </span>
              </div>
            )
          })
        )}
      </Popover.Body>
    </Popover>
  )

  return (
    <div className='zocks-py-0.75 flex-1'>
      <OverlayTrigger trigger={['hover', 'focus']} placement='auto' overlay={popover}>
        <div className='d-flex gap-2 align-items-center px-2 py-1 border border-1 zocks-border-0.5 zocks-border-color-gray-300 cross-client-match'>
          {matchIcon}
          <div className='paragraph-small medium'>{matchLabel}</div>
        </div>
      </OverlayTrigger>
    </div>
  )
}
